import { Themes, useTheme } from "@maxtropy/components";

export default function useEcharstTheme() {
  const theme = useTheme();

  return theme === Themes.DARK ? 'dark' : undefined;
}